/** `/baja` must stay reachable without a session: Disposición 954/2025 requires
 *  the cancellation link on first access, ahead of any sign-in. */
export const LEGAL_PATHS = ['/privacy', '/terms', '/baja'] as const;

export function isLegalPath(pathname: string): boolean {
  return LEGAL_PATHS.some((path) => pathname === path);
}
